(() => {
  if (window.__sportszoneMeasurementGuideLoaded) return;
  window.__sportszoneMeasurementGuideLoaded = true;

  let activeModal = null;
  let activeTrigger = null;

  const focusables = (modal) => Array.from(modal.querySelectorAll(
    'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter(el => el.offsetParent !== null);

  function openModal(trigger) {
    const id = trigger?.dataset?.szMeasureOpen;
    const modal = id ? document.getElementById(id) : null;
    if (!modal) return;

    activeModal = modal;
    activeTrigger = trigger;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('sz-measure-guide-open');

    const panel = modal.querySelector('.sz-measure-guide__panel');
    requestAnimationFrame(() => panel?.focus());
  }

  function closeModal(modal = activeModal) {
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sz-measure-guide-open');

    const trigger = activeTrigger;
    trigger?.setAttribute?.('aria-expanded', 'false');
    activeModal = null;
    activeTrigger = null;
    trigger?.focus?.();
  }

  document.addEventListener('click', event => {
    const open = event.target.closest('[data-sz-measure-open]');
    if (open) {
      event.preventDefault();
      openModal(open);
      return;
    }

    const close = event.target.closest('[data-sz-measure-close]');
    if (close) {
      event.preventDefault();
      closeModal(close.closest('[data-sz-measure-modal]'));
    }
  });

  document.addEventListener('keydown', event => {
    if (!activeModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const items = focusables(activeModal);
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();